<template>
	<div class="xmodal-wrapper" id="search-page-filters">
		<div class="xmodal-inner">
			<div class="xmodal">
				<div class="xmodal-close" @click="searchPageStore.closeFilterModal">
					X
				</div>
				<h2>{{ filterDefinition.description }}</h2>
				<div style="text-align: left; max-height: 300px; overflow-y: auto" :class="{
					modalActive: searchPageStore.searchPageState.filterModal.active,
				}">
					<SearchPageFilterOptions :filterDefinition="filterDefinition" :showAllFilterOptions="true" />
				</div>
				<div class="xmodal-buttons">
					<button @click="searchPageStore.closeFilterModal">
						Show
						{{ searchPageStore.searchPageState.query.totalCount }} Result<span
							v-if="searchPageStore.searchPageState.query.totalCount != 1">s</span>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useSearchPageStore } from "@/store/store/searchPageStore";
import { FilterDefinition } from "@/types/search-page";

import SearchPageFilterOptions from "@/components/v2/search-page/SearchPageFilterOptions.vue";

const searchPageStore = useSearchPageStore();

const filterDefinition = computed<FilterDefinition>(() =>
	searchPageStore.searchPageState.filters.find(
		(f: FilterDefinition) =>
			f.filterCategoryId ===
			searchPageStore.searchPageState.filterModal.filterCategoryId
	)
);
</script>

<style scoped>
.xpage-search-filter-modal label.xcheck {
	background-color: #eee;
}

@media screen and (max-width: 620px) {
	.xmodal-inner {
		width: 100%;
	}
}
</style>
